import { StandardButton } from '@/components/buttons/standard';
import { CustomContentSection } from '@/components/custom-content-section';
import { PrimaryLayout } from '@/layouts/primary';
import { Carousel } from '@mantine/carousel';
import { Flex, Text } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const SubscriptionPage = () => {
	const navigate = useNavigate();
	const cancelAutoRenew = useCallback(() => navigate({ to: '/cancel-auto-renew' }), [navigate]);
	return (
		<PrimaryLayout header={{ title: 'Subscription', backTo: '/home' }}>
			<Flex direction="column" gap="md" justify="space-between" align="center" flex={1} p="lg">
				<CustomContentSection
					location={ContentSectionLocation.Subscription}
					placement={ContentSectionPlacement.Top}
				/>
				<Flex direction="column" justify="center" align="center" flex={1}>
					<Carousel withIndicators withControls height="100%" classNames={styles}>
						<Carousel.Slide>
							<Text>Slide 1</Text>
						</Carousel.Slide>
						<Carousel.Slide>
							<Text>Slide 2</Text>
						</Carousel.Slide>
						<Carousel.Slide>
							<Text>Slide 3</Text>
						</Carousel.Slide>
					</Carousel>
				</Flex>
				<StandardButton variant="subtle" onClick={cancelAutoRenew}>
					Cancel Auto Renew
				</StandardButton>
				<CustomContentSection
					location={ContentSectionLocation.Subscription}
					placement={ContentSectionPlacement.Middle}
				/>
				<CustomContentSection
					location={ContentSectionLocation.Subscription}
					placement={ContentSectionPlacement.Bottom}
				/>
			</Flex>
		</PrimaryLayout>
	);
};
